<script setup>
// Aviso de pendência de pagamento na Meta (erro 131042) da caixa WhatsApp:
// os templates (fora da janela de 24h) estão sendo recusados. A marca vem do
// backend (`inbox.meta_payment_issue`) e some sozinha quando um template é
// entregue. Quem usa decide quando mostrar (ver `showMetaPaymentIssue`).
// `paymentUrl` (`inbox.meta_payment_url`) leva à tela de pagamento da Meta.
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';

defineProps({
  paymentUrl: { type: String, default: '' },
});

const { t } = useI18n();
</script>

<template>
  <div
    role="alert"
    class="flex items-start gap-2 px-4 py-2 text-xs border-b bg-n-amber-2 text-n-amber-11 border-n-amber-6"
  >
    <Icon icon="i-lucide-credit-card" class="size-4 shrink-0 mt-px" />
    <span class="flex-1">
      {{ t('CONVERSATION.META_PAYMENT_ISSUE_BANNER.MESSAGE') }}
    </span>
    <a
      v-if="paymentUrl"
      :href="paymentUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="inline-flex items-center gap-1 shrink-0 font-medium underline hover:no-underline"
    >
      {{ t('CONVERSATION.META_PAYMENT_ISSUE_BANNER.PAY_LINK') }}
      <Icon icon="i-lucide-external-link" class="size-3" />
    </a>
  </div>
</template>
